/**
 * Directive to show the consent policy widget of the user
 * USAGE:
 * <div jv-data-consent 
	   ng-model="appDetails.applicationConsent"
	   link="{{jvUrls.jhire}}/action/application/{{appDetails.application.EId}}/dataConsent"
	   seek-consent-action="seekConsent()"
	   export-data-action="exportData()"
	   >	   
	</div>	
 *
 * ng-model : the model object that has all the data consent details.
 * link : the link to view the consent policy
 * seek-consent-action : method to call on clicking of 'seek consent' link
 * export-data-action : method to call on clicking of 'export data' link
 * 
 * 
 * Fix/ Add the css if required 
 */
angular
.module('jv.Common.DataConsent', [])
.directive('jvDataConsent', [ function(){
	return {
		require: 'ngModel',
		replace: true,
		templateUrl: '/jhire/htm/common/dataConsentInfo.html',
		scope:{
			seekConsentAction: '&',			
			exportDataAction: '&',
			data: '=ngModel',
			email: '=email',
			viewEndpoint: '@link',
			exportDataVisibility: '=exportDataVisibility',
			retentionDataVisibility: '=retentionDataVisibility'
		},
		link: function(scope, iElm, iAttrs){
			scope.redDate = false;
						
			if(scope.data && scope.data.deletionDate){
				var oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds = 1 day
				var today = new Date();
				var diffDays = Math.round(Math.abs((today.getTime() - new Date(scope.data.deletionDate))/(oneDay)));
				
				if(diffDays <= 30){
					scope.redDate = true;
				}
			}

		}
	};
}]);